// extracted by mini-css-extract-plugin
module.exports = {"isHighlightedAdmittance":"ResourceCell_isHighlightedAdmittance__Z_xO"};